import React, { useState, useEffect } from 'react';
import ComposeNotification from './components/ComposeNotification';
import NotificationHistory from './components/NotificationHistory';
import NotificationModal from './components/NotificationModal';
import useMarketingAndNotificationStore from '@/stores/AdminStore/MarketingAndNotificationStore';
import { NotificationRecord } from '@/services/PagesServices/MarketingAndNotificationService';
import './MarketingAndNotification.css';

const MarketingAndNotification: React.FC = () => {
  const [activeTab, setActiveTab] = useState('compose');
  const [selectedNotification, setSelectedNotification] = useState<NotificationRecord | null>(null);
  const [showModal, setShowModal] = useState(false);

  const {
    audiences,
    notificationHistory,
    fetchAudiences,
    fetchNotificationHistory,
  } = useMarketingAndNotificationStore();

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'compose' && !audiences) {
      fetchAudiences();
    }
    if (activeTab === 'history' && !notificationHistory) {
      fetchNotificationHistory();
    }
  }, [activeTab, audiences, notificationHistory, fetchAudiences, fetchNotificationHistory]);

  const handleViewNotification = (notification: NotificationRecord) => {
    setSelectedNotification(notification);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedNotification(null);
  };

  return (
    <div className="trainer-marketing-container">
      <div className="trainer-marketing-breadcrumb">
        <span className="trainer-marketing-breadcrumb-item">Tools</span>
        <span className="trainer-marketing-breadcrumb-separator">›</span>
        <span className="trainer-marketing-breadcrumb-item trainer-marketing-breadcrumb-active">Marketing</span>
      </div>

      <div className="trainer-marketing-header">
        <h1 className="trainer-marketing-title">Tools</h1>
        <p className="trainer-marketing-subtitle">Administrative utilities and system tools</p>
      </div>

      <div className="trainer-marketing-tabs">
        <button
          className={`trainer-marketing-tab ${activeTab === 'compose' ? 'trainer-marketing-tab-active' : ''}`}
          onClick={() => setActiveTab('compose')}
        >
          Compose Notification
        </button>
        <button
          className={`trainer-marketing-tab ${activeTab === 'history' ? 'trainer-marketing-tab-active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Notification History
        </button>
        <button
          className={`trainer-marketing-tab ${activeTab === 'tags' ? 'trainer-marketing-tab-active' : ''}`}
          onClick={() => setActiveTab('tags')}
        >
          Audience Tags
        </button>
      </div>

      {activeTab === 'compose' && (
        <div className="trainer-marketing-content">
          <ComposeNotification />
        </div>
      )}

      {activeTab === 'history' && (
        <div className="trainer-marketing-content">
          <NotificationHistory onViewNotification={handleViewNotification} />
        </div>
      )}

      {activeTab === 'tags' && (
        <div className="trainer-marketing-content">
          <h2 className="trainer-marketing-section-title">Audience Tags</h2>
          <p className="trainer-marketing-section-subtitle">Manage and organize your audience segments</p>
          {/* Add Audience Tags content here */}
        </div>
      )}

      {showModal && (
        <NotificationModal
          notification={selectedNotification}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default MarketingAndNotification;
